import script from "./InfoBars.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoBars.vue?vue&type=script&setup=true&lang=js"

import "./InfoBars.vue?vue&type=style&index=0&id=0f28c241&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f28c241"]])

export default __exports__